// extracted by mini-css-extract-plugin
export default {"overlay":"MediaList_overlay__ophTr"};